import { typeOptions } from '../utils/options.js';
export default {
    page1: (state) => {
        return state.info.page1 || {};
    },
    page2: (state) => {
        return state.info.page2 || {};
    },
    page3: (state) => {
        return state.info.page3 || {};
    },
    page4: (state) => {
        return state.info.page4 || {};
    },
    page5: (state) => {
        return state.info.page5 || {};
    },
    page6: (state) => {
        return state.info.page6 || {};
    },
    page7: (state) => {
        return state.info.page7 ? state.info.page7.famous_scene_urls || [] : [];
    },
    page8: (state) => {
        return state.info.page8 || {};
    },
    generatorImg: (state) => {
        let img = '';
        if (state.showInfo && state.showInfoImg) {
            img = state.showInfoImg;
        }
        if (!state.showInfo && state.hideInfoImg) {
            img = state.hideInfoImg;
        }
        return img;
    },
    radarInfo: (state) => {
        const info = state.info;
        if (info.page1 && Object.keys(info.page1).length) {
            const list = info.page1.viewed_type_and_num || [];
            let final = [];
            const maxNumber = list.map(i => Number(i.watched_num)).sort((a, b) => b - a)[0];
            const base = maxNumber > 3 ? 10 : 8;
            list.forEach(i => {
                final = [
                    ...final,
                    {
                        value: Math.max(1, Math.ceil((i.watched_num * base) / maxNumber)),
                        label: typeOptions[i.watched_type] || '',
                    },
                ];
            });
            return final;
        }
        else {
            return null;
        }
    },
    showMovieList: (state) => {
        return state.finalList.slice(state.pageNo * 4, state.pageNo * 4 + 4);
    },
    hideTop: (state) => {
        if (window.isPC) {
            return state.h5Height <= 560;
        }
        if (state.height) {
            return state.height <= 600;
        }
    },
    h5WidthStyle: (state) => {
        return {
            width: `${state.h5Width}px`,
        };
    },
    h5HeightStyle: (state) => {
        return {
            height: `${state.h5Height}px`,
        };
    },
};
